<script>
export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
import { onMounted } from 'vue'
import DefaultFull from '../../default/groups/Full.vue'
import ToFullTopLeft from '../transitions/rectangle/ToFullTopLeft.vue'
import ToTransTopLeft from '../transitions/rectangle/ToTransTopLeft.vue'

const props = defineProps({
  item: Array,
})

const transitionComponent = ref(null)
const transitionEndComponent = ref(null)

onMounted(() => {
  transitionComponent.value.start()
})

const { onDisappear } = useDisappearable()
onDisappear(async () => await transitionEndComponent.value.start())
</script>

<template>
  <ToFullTopLeft ref="transitionComponent">
    <ToTransTopLeft ref="transitionEndComponent">
      <DefaultFull v-bind="props" />
    </ToTransTopLeft>
  </ToFullTopLeft>
</template>
